import A11yDialog from '../../../../node_modules/a11y-dialog/dist/a11y-dialog'
import Glider from '../../../js/glider'

require('./_modal-gallery.scss')
require('../../../../node_modules/a11y-dialog/dist/a11y-dialog')
require('../../../js/glider')

const ModalGallery = {

  init: function (element) {
    const dialogId = element.getAttribute('id')
    const dialog = new A11yDialog(element)
    const triggers = document.querySelectorAll('[data-a11y-dialog-show="' + dialogId + '"]')

    // fix carousel not displaying properly when opened
    dialog.on('show', function (element, event) {
      window.dispatchEvent(new Event('resize'))
    })

    for (const trigger of triggers) {
      trigger.addEventListener('click', (e) => {
        e.preventDefault()
        const galleryIndex = trigger.getAttribute('data-gallery-index')
        const gliderElement = Glider(element.querySelector('.glider'))

        // fix carousel not displaying properly when opened
        window.dispatchEvent(new Event('resize'))

        // scroll to correct item without animation if specified
        if(galleryIndex) {
          gliderElement.setOption({ duration: 0 })
          gliderElement.scrollItem(galleryIndex, true)
          gliderElement.setOption({ duration: 0.25 })
        }
      }, false)
    }
  }
}

export default ModalGallery
